import { gql } from "@apollo/client";

const TourQuery = gql`
  query ViewTour($tourName: String!) {
    view_tour(tour_name: $tourName)
  }
`;

export default TourQuery;
